import { useGetWhoamiQuery } from "Services";
import { selectAuth } from "Store/auth.slice";
import { useAppSelector } from "./index";

const useIsAuthenticated = () => {
  useGetWhoamiQuery();

  return useAppSelector(selectAuth);
};

export default useIsAuthenticated;
